import React, { useEffect, useState } from "react"
import { useUserData } from "@lib/context/ComponentContext"
import AuthServices from "@services/auth.services"
import clsx from "clsx"
import { container, FlexBox } from "@components/wrapper"
import { HARISENIN_LOGO, HARISENIN_LOGO_WHITE } from "@const/pictures"
import { FaCheckCircle } from "react-icons/fa"
import { HeaderComponent } from "./components"
import dynamic from "next/dynamic"
import HeaderMobile from "./components/HeaderMobile"
import { AppImage as Image } from "@components/misc"
import NextImage from "next/image"
import Link from "next/link"
import { destroyCookie } from "nookies"
import { useRouter } from "next/router"
import { HeaderMenuProvider, useHeaderMenu } from "./context/HeaderMenuContext"

// Login form (formik, yup, Google login) loads only once a visitor opens it.
const LoginModal = dynamic(() => import("@components/modal/LoginModal").then((m) => m.LoginModal))

interface HeaderProps {
  transparent?: boolean
  isNotSticky?: boolean
  bgOnly?: boolean
}

export function Header(props: HeaderProps) {
  return (
    <HeaderMenuProvider>
      <HeaderInner {...props} />
    </HeaderMenuProvider>
  )
}

function HeaderInner({ transparent, isNotSticky, bgOnly }: HeaderProps) {
  const [loginModal, setLoginModal] = useState(false)
  const [loginModalUsed, setLoginModalUsed] = useState(false)
  const [unverifiedStatus, setUnverifiedStatus] = useState(false)
  const [isToastOpen, setIsToastOpen] = useState(false)
  const { isMenuOpen } = useHeaderMenu()

  const { tokenData, isLogin } = useUserData()
  const auth = new AuthServices()
  // const { analytics } = useAnalytics()
  const { query } = useRouter()

  useEffect(() => {
    const initIdentify = async () => {
      try {
        const res = await auth.getUserData()

        if (res.isSuccess) {
          const result = res.getValue()
          // analytics.identify(tokenData?.id, result)
        }
      } catch (error) {
        console.log(error)
      }
    }

    if (!tokenData?.user_active && isLogin) {
      setUnverifiedStatus(true)
    }

    if (query?.authenticated) {
      destroyCookie(null, "HS_TEMP")
    }

    if (isLogin) {
      initIdentify()
    }
  }, [tokenData])

  const handleOpenLogin = () => {
    setLoginModalUsed(true)
    setLoginModal(true)
  }
  const handleCloseLogin = () => {
    setLoginModal(false)
  }

  const sendEmail = async () => {
    try {
      await auth.resendVerificationEmail(tokenData?.user_email as string)
      setIsToastOpen(true)

      setTimeout(() => setIsToastOpen(false), 3000)
    } catch (e) {
      if (process.env.NODE_ENV === "development") {
        console.log(e)
      }
    }
  }

  const isWhiteLogo = Boolean(transparent && !bgOnly && !isMenuOpen)

  return (
    <>
      {/* Both variants are server-rendered and switched by CSS: swapping them after hydration shifted the page (CLS). */}
        <div
          className={clsx(
            "top-0 z-[1000] max-[768px]:hidden",
            isMenuOpen && "bg-white !text-black-22",
            isNotSticky ? "fixed" : "sticky",
            transparent && !bgOnly && "text-white",
            transparent ? `w-full fixed transition ease-in` : "bg-white w-full"
          )}
        >
          {/* Header Component */}
          <div className="static">
            <FlexBox align="center" justify="between" className={clsx(container, "py-4")}>
              {/* Logo */}
              <FlexBox align="center">
                <Link href="/" passHref={true}>
                  {/* Eager but not preloaded: the 30 KB logo must not compete with the LCP image. */}
                  <NextImage
                    src={isWhiteLogo ? HARISENIN_LOGO_WHITE : HARISENIN_LOGO}
                    alt="harisenin.com logo"
                    loading="eager"
                    className="h-[25px] w-auto"
                    // the white PNG is 178x26; the SVG is 2390x341
                    width={isWhiteLogo ? 171 : 175}
                    height={25}
                  />
                </Link>
              </FlexBox>

              <HeaderComponent
                loginModalHandler={handleOpenLogin}
                isLogin={isLogin}
                tokenData={tokenData}
                transparent={Boolean(transparent && !bgOnly && !isMenuOpen)}
              />
            </FlexBox>
          </div>

          {unverifiedStatus && (
            <div className="bg-[#FEDE00] py-2 text-center text-black">
              Silahkan cek email Anda untuk melakukan verifikasi atau{" "}
              <u className="cursor-pointer underline text-new-blue" onClick={sendEmail}>
                klik di sini
              </u>{" "}
              untuk kirim ulang email verifikasi.
            </div>
          )}

          <FlexBox
            justify="center"
            align="center"
            className={clsx(
              "z-[1000] fixed top-[50px] left-1/2 w-[300px] ml-[-150px] bg-green-a11y text-white rounded text-center p-3 lg:text-base text-sm gap-2",
              isToastOpen ? "visible show_toast" : "invisible"
            )}
          >
            <FaCheckCircle /> Email Verifikasi berhasil dikirim
          </FlexBox>
        </div>
      <div className="contents min-[769px]:hidden">
        <HeaderMobile loginModalHandler={handleOpenLogin} isLogin={isLogin} tokenData={tokenData} />
      </div>

      {loginModalUsed && <LoginModal show={loginModal} onClose={handleCloseLogin} />}
    </>
  )
}
